//////////////////////////////////////////////////////
/// DO NOT EDIT                                    ///
/// Generated by Trygghetsfonden.Dataverse.Tools   ///
/// Source file: xrm.context.include.txt           ///
//////////////////////////////////////////////////////

export enum tsl_projektdeltagande_tsl_anstallningsform {
	Tillsvidareanstlld = 866190000,
	Tidsbegrnsatanstlld = 866190001,
};
